<template>
  <div class="text-viewer">
    <div v-if="error" class="error">{{ error }}</div>
    <div v-else-if="loading">
      {{ t('loading') }}
    </div>
    <div v-else>
      <div class="pdf-controller">
      <div class="pdf-controller-inner">
        <button :title="[isWrapped ? 'Orijinali Gör' : 'Sayfaya Sığdır']" class="btn btn-sm navigationButtons" @click="toggleWrap">
          <svg v-if="!isWrapped" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 7h14M5 12h11c1 0 3 .5 3 2.5S17.333 17 16.5 17H12m-7 0h4m3 0 2-2m-2 2 2 2"/></svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 800 800" fill="none">
            <path d="M166.667 233.334H633.334M166.667 400.001H633.334M166.667 566.667H633.334" stroke="#fff" stroke-width="66.6667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
      <div class="content-container" :class="{ 'nowrap': !isWrapped }">
        <pre :style="computedStyle">{{ content }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TextViewer',
  props: {
    url: {
      type: String,
      required: true
    },
    textStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      content: '',
      error: null,
      isWrapped: false,
      defaultStyle: {
        fontSize: '14px',
      },
      loading: false,
    }
  },
  computed: {
    computedStyle() {
      return {
        ...this.defaultStyle,
        ...this.textStyle,
        whiteSpace: this.isWrapped ? 'pre-wrap' : 'pre',
        wordWrap: this.isWrapped ? 'break-word' : 'normal'
      }
    }
  },
  watch: {
    url: {
      immediate: true,
      handler: 'fetchContent'
    }
  },
  methods: {
    async fetchContent() {
      try {
        this.loading = true;
        const response = await axios.get(this.url, {
          responseType: 'blob'
        })

        const reader = new FileReader()
        reader.onload = () => {
          this.content = reader.result
        }
        reader.readAsText(new Blob([response.data]))
        this.loading = false;
      } catch (err) {
        this.error =  'Doküman indirilirken bir hata oldu.'
        this.loading = false;
        console.error(err)
      }
    },
    toggleWrap() {
      this.isWrapped = !this.isWrapped
    }
  }
}
</script>

<style scoped>
.text-viewer {
  margin-top: 50px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.controls {
  padding: 10px;
}

.content-container {
  flex-grow: 1;
  overflow: auto;
}

.content-container.nowrap {
  white-space: nowrap;
}

.error {
  color: red;
}


.pdf-controller{
  position: fixed;
  z-index: 999;
  display: flex;
  right: 10px;
  bottom: 10px;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}


.pdf-controller-inner{
  display: flex;
  flex-direction: column;
  padding: 2px;
  align-items: center;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.216);
  background-color: #323232;
  color: #ddd;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
}
</style>